import type React from 'react';
import { styled } from 'styled-components';

import { CheckboxContainer } from '../../Form/Checkbox/index.tsx';
import Label from '../Label/index.tsx';

const Wrapper = styled(Label)`
  display: inline-flex;
  height: 38px;
  align-items: center;
  position: relative;
  cursor: pointer;
  ${CheckboxContainer} {
    margin-right: 5px;
  }
`;

export interface ICheckbox extends React.PropsWithChildren {
  dataTestId?: string;
}

const Checkbox: React.FC<ICheckbox> = ({ children, dataTestId }) => <Wrapper data-testid={dataTestId}>{children}</Wrapper>;

export default Checkbox;
